<div id="buyTicketModalCenter" style="color: white;" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div style="margin: 0px;" role="document">
    <div style="background-color: #171717 !important;font-family: 'Poppins Regular'; font-size: initial;">
      <div *ngIf="!finalPaymentStage" class="modal-header" style="border-bottom: 1px solid #e5e5e5 !important;">
        <h1 style="display: contents; font-family: 'Poppins Regular';" (click)="closeModal()" class="modal-title">
          {{modalTitle}}</h1>
        <button style="background-color: #171717 !important; color: white; border: 0;" type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span style="font-size: xx-large;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <app-buy-functionality *ngIf="buyTksStage && !errorMessage.isError" [eventId]="eventId" [premiere]="premiere" [allAccessPassStage]="allAccessPassStage"
        (enableCart)="enableCart($event)" (changeError)="changeError($event)"></app-buy-functionality>
      <app-cart-functionality *ngIf="cartStage && !errorMessage.isError" (checkOut)="enableCheckOut($event)"></app-cart-functionality>
      <app-payment-functionality [transferURL]="transferURL" *ngIf="finalPaymentStage && !errorMessage.isError">
      </app-payment-functionality>
      <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
      <div *ngIf="errorMessage.isError" class="modal-body">
        <p>{{errorMessage.errorMessage}}</p>
      </div>
    </div>
  </div>
</div>
